"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./src/index");
exports.Angular2FontawesomeModule = index_1.Angular2FontawesomeModule;



//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/angular2-fontawesome/angular2-fontawesome.js
// module id = ../../../../angular2-fontawesome/angular2-fontawesome.js
// module chunks = vendor